import type { SVGProps } from 'react';

export const Upload = (props: SVGProps<any>) => (
  <svg 
    fill="none" 
    height="20" 
    role="img" 
    viewBox="0 0 20 20" 
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
     <title>{'upload'}</title>
    <path d="M1.5 7L8.99999 1L16.5 7" stroke="#898C9A" strokeWidth="1.5"/>
    <path d="M0 19H19.5M8.99999 14.5V1.75" stroke="#898C9A" strokeWidth="1.5"/>
  </svg>
);
